import React from "react";

// ==== Import Images ====
import img05 from "../../../images/about/about-us-1.png";
import img06 from "../../../images/about/about-us-2.png";
import img07 from "../../../images/about/about-us-3.png";
import img08 from "../../../images/about/about-us-4.png";



import gif1 from "../../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../../images/icon/b10c3e43e836d32554bf.gif";

import featureIcon1 from "../../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../../images/icon/feature-icon03.svg";

import aboutBg from "../../../images/bg/about-bg02.png";
import { Link } from "react-router-dom";

const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-40">

      <div className="container">
        {/* ===== Top Scrolling Images ===== */}
        <div className="about-top-image ul_li_between align-items-start mobile-scroll-container">

          {/* Column 1 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              <Link to="/about">
                <img src={img05} alt="about" />
              </Link>
            </div>
          </div>

          {/* Column 2 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              <Link to="/about">
                <img src={img06} alt="about" />
              </Link>
            </div>
          </div>

          {/* Video */}
          <div className="xb-video">
            <video
              loop
              muted
              playsInline
              autoPlay
            >
              <source src="https://www.pexels.com/download/video/18069701/" />
            </video>
          </div>

          {/* Column 3 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              <Link to="/about">
                <img src={img07} alt="about" />
              </Link>
            </div>
          </div>

          {/* Column 4 */}
          <div className="img-hove-effect">
            <div className="xb-img">
              <Link to="/about">
                <img src={img08} alt="about" />
              </Link>
            </div>
          </div>
        </div>

        {/* ===== Title Section ===== */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Who We are?</span>

          <h2 className="title">
            We're building the future of work, right here in Toronto.
          </h2>

          <p className="content">
            Most AI firms focus on code and processing speeds. At TorqAI, we focus on your results. We founded our Toronto agency because we saw founders buried in busywork. We watched phones ring unanswered and great hires slip through messy pipelines. We knew business owners needed a better way to manage the tasks that stall growth.<br /><br />
            Our philosophy is straightforward. Tech should adapt to your business. We built a specialized suite of AI agents like CAPRO for calls and HAPRO for recruitment to solve real problems. These tools talk to your customers naturally, screen candidates with logic, and stay active 24/7.<br /><br />
            When you partner with us, you get a dedicated team that values your time and your conversion rates. We handle the repetitive manual work so you can stay focused on the big picture. Our goal is to ensure your business never misses another opportunity.
          </p>
        </div>

        {/* ===== Feature Boxes ===== */}
        <div className="row mt-40">
          {/* 1 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item" style={{ height: "100%" }}>
              <div className="xb-item--inner xb-border" style={{ height: "100%" }}>
                <span className="xb-item--icon">
                  <img src={featureIcon1} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Enterprise Security</h2>
                  <p className="xb-item--content">
                    We use end-to-end encryption and SOC 2 compliant infrastructure to keep your information safe. Your data remains protected at every single touchpoint, so you never have to worry about privacy.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item" style={{ height: "100%" }}>
              <div className="xb-item--inner xb-border" style={{ height: "100%" }}>
                <span className="xb-item--icon">
                  <img src={featureIcon2} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Measurable ROI</h2>
                  <p className="xb-item--content">
                    Every agent comes with built-in analytics. You can track exactly how they are performing through clear KPIs and real-time dashboards that show your actual returns.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 3 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item" style={{ height: "100%" }}>
              <div className="xb-item--inner xb-border" style={{ height: "100%" }}>
                <span className="xb-item--icon">
                  <img src={featureIcon3} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Seamless Integration</h2>
                  <p className="xb-item--content">
                    Connect your favorite tools instantly. We have pre-built connectors for Salesforce, HubSpot, Greenhouse, and others, along with a robust API for your custom workflows.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
